import { render, staticRenderFns } from "./AssetQRcode.vue?vue&type=template&id=2bedea9f&scoped=true"
import script from "./AssetQRcode.vue?vue&type=script&lang=js"
export * from "./AssetQRcode.vue?vue&type=script&lang=js"
import style0 from "./AssetQRcode.vue?vue&type=style&index=0&id=2bedea9f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedea9f",
  null
  
)

export default component.exports